export default __webpack_public_path__ + "static/media/background-parachute-2x.e9c2dccc.png";